import dayjs from 'dayjs';
import { split, map, join, orderBy } from 'lodash';

export const asMarkLogicDate = (date) => {
  if (!date) return null;

  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) return null;
  return dayjsDate.format('YYYY-MM-DD');
};

export const displayDate = (date) => {
  if (!date) return '';

  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) return date;
  return dayjsDate.format('DD/MM/YYYY');
};

export const displayDateTime = (date) => {
  if (!date) return '';

  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) return date;
  return dayjsDate.format('DD/MM/YYYY HH:mm');
};

export const displayYear = (date) => {
  if (!date) return '';

  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) return date;
  return dayjsDate.format('YYYY');
};

export const displayMonitoringYear = (monitoringDateStr) => {
  if(!monitoringDateStr) return  '';
  if(monitoringDateStr.indexOf(' ') > -1) {
    const multiYearDisplay = map(split(monitoringDateStr, ' '), moniDateStr => {
      return displayYear(moniDateStr)
    });

    return join(orderBy(multiYearDisplay, [], ['desc']), ', ');
  }
  return displayYear(monitoringDateStr);
};